var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _vm.isDropdownOpen ? _c("div", { staticClass: "bg-overlay" }) : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "button-floater animated bounceIn",
        class: { "push-higher": _vm.selectedDocumentsIndex.length },
        on: {
          click: function ($event) {
            _vm.disablePlusButton
              ? _vm.openWarningSnackBar(
                  _vm.constants.STRINGS.ERRORS
                    .DO_NOT_HAVE_MINIMUM_LEVEL_PERMISSION
                    .TO_CREATE_OR_UPLOAD_FILES
                )
              : null
          },
        },
      },
      [
        _c(
          "b-dropdown",
          {
            staticClass: "pt-2",
            attrs: {
              disabled: _vm.disablePlusButton,
              "aria-role": "list",
              "mobile-modal": false,
              position: "is-top-left",
            },
            on: { "active-change": (b) => (_vm.isDropdownOpen = b) },
          },
          [
            _c(
              "div",
              {
                staticClass: "plus-button",
                attrs: { slot: "trigger", role: "button" },
                slot: "trigger",
              },
              [
                _c("div", { staticClass: "has-text-centered is-size-3" }, [
                  _c("i", { staticClass: "fas fa-plus has-text-white" }),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              {
                class: _vm.canUploadDocuments ? "" : "disabled-option",
                attrs: { "aria-role": "listitem" },
                on: {
                  click: function ($event) {
                    _vm.canUploadDocuments
                      ? _vm.uploadDocuments()
                      : _vm.openWarningSnackBar(
                          _vm.constants.STRINGS.ERRORS
                            .DO_NOT_HAVE_MINIMUM_LEVEL_PERMISSION
                            .TO_UPLOAD_DOCUMENT
                        )
                  },
                },
              },
              [
                _c("i", { staticClass: "far fa-copy fa-fw fa-lg" }),
                _vm._v(" Documentos"),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-dropdown-item",
              {
                class: _vm.canCreateFolder ? "" : "disabled-option",
                attrs: { "aria-role": "listitem" },
                on: {
                  click: function ($event) {
                    _vm.canCreateFolder
                      ? _vm.createFolder()
                      : _vm.openWarningSnackBar(
                          _vm.constants.STRINGS.ERRORS
                            .DO_NOT_HAVE_MINIMUM_LEVEL_PERMISSION
                            .TO_CREATE_FOLDER
                        )
                  },
                },
              },
              [
                _c("i", { staticClass: "far fa-folder fa-fw fa-lg" }),
                _vm._v(" Carpeta"),
              ]
            ),
            _vm._v(" "),
            _vm.$store.getters.hasAnyRole(["lyris", "serie-user"])
              ? _c(
                  "b-dropdown-item",
                  {
                    class: _vm.canCreateCompositeUnit ? "" : "disabled-option",
                    attrs: { "aria-role": "listitem" },
                    on: {
                      click: function ($event) {
                        _vm.canCreateCompositeUnit
                          ? _vm.createCompositeUnit()
                          : _vm.openWarningSnackBar(
                              _vm.constants.STRINGS.ERRORS
                                .DO_NOT_HAVE_MINIMUM_LEVEL_PERMISSION
                                .TO_CREATE_COMPOSITE_UNIT
                            )
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "far fa-file-archive fa-fw fa-lg" }),
                    _vm._v(" Unidad compuesta"),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }